import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {useTranslation} from '@app/hooks/use-translation';
import {Image} from '@app/components/Image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const IndexSummerSection = () => {
	const {t} = useTranslation();

	return (
		<LandingIllustrationSection
			imagePosition="right"
			description={
				<>
					<LandingHeading as="h2">
						{t('hubmomentslandingpage_title_summer_standalone-web', {
							ns: 'moments',
						})}
					</LandingHeading>
					<LandingParagraph>
						{t('hubmomentslandingpage_text_summer_standalone-web', {
							ns: 'moments',
						})}
					</LandingParagraph>
				</>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'summer'}}
					href={'/moments/summer'}
				>
					{t('footer_title_summermusic_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
			image={
				<Image
					sizes={{base: '100vw', md: '50vw'}}
					h={{base: '350px', md: '100%'}}
					src="eb0dc57d5537caf0ddd7f85cc9ad8821.jpg"
					aspectRatio="1440/1200"
					alt={t('metatag_text_chillwithmusic_standalone-web', {ns: 'common'})}
					priority
				/>
			}
		/>
	);
};
